<template>
    <a href="#" class="flex items-center flex-1 w-full px-16 py-10 sm:px-24 sm:py-18 overflow-hidden self-animate bg-white rounded-md group border-3 border-white hover:bg-transparent">
        <div>
    <span class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
      <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
          <template v-if="iconNotes"><IconNotesSVG class="w-24 h-24"/></template>
          <template v-if="iconDocs"><IconDocsSVG class="w-24 h-24"/></template>
          <template v-if="iconReports"><IconReportsSVG class="w-24 h-24"/></template>
          <template v-if="iconCart"><IconCartSVG class="w-24 h-24"/></template>
          <template v-if="iconStar"><IconStarSVG class="w-24 h-24"/></template>
      </span>
    </span>
        </div>

        <div class="flex-1 mx-16">
            <div class="inline-flex flex-col sm:items-center sm:flex-row">
                <h3 class="font-normal text-black title-lg">{{title}}</h3>

<!--                <div v-if="tagContent" class="mr-4 mt-4 sm:mt-0 sm:ml-8 self-tag" :class="`bg-${tagColor}`">{{tagContent}}</div>-->
            </div>

            <div class="pt-8">
                <p>{{intro}}</p>
            </div>
        </div>

        <div>
      <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
        <IconArrowForwardSVG/>
      </span>
        </div>
    </a>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconNotesSVG from '../assets/static/icons-src/icon-notes.svg'
import IconCartSVG from '../assets/static/icons-src/icon-cart.svg'
import IconDocsSVG from '../assets/static/icons-src/icon-docs.svg'
import IconStarSVG from '../assets/static/icons-src/icon-star.svg'
import IconReportsSVG from '../assets/static/icons-src/icon-reports.svg'
import IconArrowForwardSVG from '../assets/static/icons-src/icon-arrow-forward.svg'
@Component({
    components: {
        IconNotesSVG,
        IconCartSVG,
        IconDocsSVG,
        IconStarSVG,
        IconReportsSVG,
        IconArrowForwardSVG
    }
})
export default class Card extends Vue {
    @Prop({ type: String, required: true }) title!: string;
    @Prop({ type: String, required: true }) intro!: string;
    @Prop(String) tagContent!: string;
    @Prop(String) tagColor!: string;
    @Prop(Boolean) iconNotes!: boolean;
    @Prop(Boolean) iconDocs!: boolean;
    @Prop(Boolean) iconReports!: boolean;
    @Prop(Boolean) iconStar!: boolean;
    @Prop(Boolean) iconCart!: boolean;
}
</script>

<style scoped>

</style>
